var React = require('react');

function ArrowExternalTopRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.74262 2.32844L8.39948 2.32844V6.98529","stroke":"#AEACA4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M7.69239 3.03551L2.32843 8.39948","stroke":"#AEACA4","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowExternalTopRightInline.defaultProps = {"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none"};

module.exports = ArrowExternalTopRightInline;

ArrowExternalTopRightInline.default = ArrowExternalTopRightInline;
